import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ImageIcon } from 'lucide-react';
import { JerseySelectorModal } from './JerseySelectorModal';

interface JerseyPickerButtonProps {
  onSelect: (url: string) => void;
  fieldLabel?: string;
}

export function JerseyPickerButton({ onSelect, fieldLabel }: JerseyPickerButtonProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setModalOpen(true)}
        className="shrink-0"
      >
        <ImageIcon className="h-4 w-4" />
      </Button>
      <JerseySelectorModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onSelect={onSelect}
        fieldLabel={fieldLabel}
      />
    </>
  );
}
